/* Nina Comfort – comportamento das páginas cf (código próprio, sem scripts de terceiros) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) {
    var f = (window.cfShop && cfShop.moneyFormat) || '${{amount}}';
    var v = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  /* ---------- header height ---------- */
  function setHeaderHeight() {
    var h = $('.section-header');
    var v = h && getComputedStyle(h).display !== 'none' ? h.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-height', v + 'px');
  }
  setHeaderHeight(); window.addEventListener('resize', setHeaderHeight);

  /* ---------- Splide (anúncio / icon bars) ---------- */
  function initSplides() {
    if (!window.Splide) return;
    $$('splide-component').forEach(function (el) {
      if (el.dataset.cfInit) return; el.dataset.cfInit = '1';
      var root = $('.splide', el); if (!root) return;
      var d = el.dataset, mob = isMobile();
      if (!mob && d.destroyDesktop === 'true') return;
      var per = +(mob ? d.slidesMobile : d.slidesDesktop) || 1;
      var gap = +(mob ? d.gapMobile : d.gapDesktop) || 0;
      var pad = +(mob ? d.sidePaddingMobile : d.sidePaddingDesktop) || 0;
      var opts = {
        type: d.type || 'slide', perPage: per, perMove: +(d.perMoveDesktop || 1), gap: gap,
        autoplay: d.autoplay === 'true', interval: (+d.autoplaySpeed || 5) * 1000,
        arrows: d.arrows !== 'false', pagination: d.pagination !== 'false' && d.dots !== 'false',
        padding: pad ? { left: pad, right: pad } : 0, pauseOnHover: true, drag: true
      };
      try { new Splide(root, opts).mount(); } catch (e) { }
      if (d.arrowsColor) $$('.splide__arrow', root).forEach(function (a) { a.classList.add('color-' + d.arrowsColor); });
    });
  }

  /* ---------- menu mobile (details) ---------- */
  $$('header-drawer details, details.menu-drawer-container, #Details-menu-drawer-container').forEach(function (det) {
    var sum = $('summary', det); if (!sum || sum.dataset.cf) return; sum.dataset.cf = 1;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (det.hasAttribute('open')) { det.classList.remove('menu-opening'); setTimeout(function () { det.removeAttribute('open'); }, 250); document.body.classList.remove('overflow-hidden-mobile'); }
      else { det.setAttribute('open', ''); requestAnimationFrame(function () { det.classList.add('menu-opening'); }); document.body.classList.add('overflow-hidden-mobile'); }
    });
  });
  $$('.menu-drawer details').forEach(function (det) {
    var sum = $('summary', det); if (!sum) return;
    sum.addEventListener('click', function (e) { e.preventDefault(); if (det.hasAttribute('open')) { det.classList.remove('menu-opening'); det.removeAttribute('open'); } else { det.setAttribute('open', ''); det.classList.add('menu-opening'); } });
    $$('.menu-drawer__close-button', det).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); det.classList.remove('menu-opening'); det.removeAttribute('open'); }); });
  });
  $$('header-menu details, .header__inline-menu details').forEach(function (det) {
    det.addEventListener('mouseenter', function () { det.setAttribute('open', ''); });
    det.addEventListener('mouseleave', function () { det.removeAttribute('open'); });
  });

  /* ---------- modais (tabela de tamanho, zoom) ---------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('modal-opener[data-modal] button, modal-opener[data-modal]');
    if (op) {
      var mo = op.closest('modal-opener');
      var m = mo && mo.dataset.modal && document.querySelector(mo.dataset.modal);
      if (m) { e.preventDefault(); m.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); return; }
    }
    var cl = e.target.closest('[id^="ModalClose-"], .product-popup-modal__toggle, .product-media-modal__toggle');
    if (cl) { var md = cl.closest('modal-dialog, product-modal'); if (md) { md.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); } }
  });
  $$('modal-dialog, product-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) { m.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); } });
    if (m.parentElement !== document.body) document.body.appendChild(m);
  });

  /* ---------- mobile: nota + título acima da galeria (como a origem) ---------- */
  (function () {
    if (!isMobile()) return;
    var mw = $('.product__media-wrapper'), pi = $('product-info');
    if (!mw || !pi || $('.dev-cf-6', mw)) return;
    var box = document.createElement('div'); box.className = 'dev-cf-6 dev-cf-6-executed';
    ['.rating-stars', '.product__title'].forEach(function (s) { var el = $(s, pi); if (el) box.appendChild(el); });
    mw.insertBefore(box, mw.firstChild);
  })();

  /* ---------- galeria ---------- */
  function initGallery(g) {
    var list = $('.product__media-list', g); if (!list) return;
    var slides = $$('.product__media-item', list);
    var thumbs = $$('.thumbnail-list__item', g);
    var cur = $('.slider-counter--current', g), tot = $('.slider-counter--total', g);
    if (tot) tot.textContent = slides.length;
    function show(i, scroll) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { var b = $('button', t); if (b) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); } });
      if (cur) cur.textContent = i + 1;
      if (scroll) list.scrollTo({ left: list.scrollLeft + slides[i].getBoundingClientRect().left - list.getBoundingClientRect().left, behavior: isMobile() ? 'smooth' : 'auto' });
      var tl = $('.thumbnail-list', g); var t = thumbs[i];
      if (tl && t) tl.scrollTo({ left: t.offsetLeft - tl.offsetLeft - tl.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      g.dataset.cfIndex = i;
    }
    g.cfShow = show;
    thumbs.forEach(function (t, k) { var b = $('button', t); if (b) b.addEventListener('click', function (e) { e.preventDefault(); show(k, true); }); });
    $$('.slider-button--next', g).forEach(function (b) { b.disabled = false; b.removeAttribute('disabled'); b.addEventListener('click', function (e) { e.preventDefault(); show((+g.dataset.cfIndex || 0) + 1, true); }); });
    $$('.slider-button--prev', g).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show((+g.dataset.cfIndex || 0) - 1, true); }); });
    list.addEventListener('scroll', function () {
      var w = slides[1] ? slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left : (slides[0] ? slides[0].offsetWidth : 1); var i = Math.round(list.scrollLeft / w);
      if (cur) cur.textContent = Math.min(slides.length, i + 1);
      if (isMobile() && +g.dataset.cfIndex !== i) { g.dataset.cfIndex = i; slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); }); }
    }, { passive: true });
    g.dataset.cfIndex = 0;
  }
  $$('media-gallery').forEach(initGallery);

  /* ---------- produto: variantes, gênero, pares (BOGO) ---------- */
  var P = window.cfProduct;
  function findVariant(opts) {
    if (!P) return null;
    return P.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; }); }) || null;
  }
  function genderShift(size, women) {
    if (!women) return size;
    var m = /^US (\d+(?:\.5)?)$/.exec(size); if (!m) return size;
    return 'US ' + (parseFloat(m[1]) + 2).toString();
  }
  var info = $('product-info');
  if (P && info) {
    var vs = $('variant-selects', info);
    var selects = vs ? $$('select.select__select', vs) : [];
    var women = false;
    var colorIdx = P.options.findIndex(function (o) { return /color|colour/i.test(o.name || o); });
    function currentOpts() { return selects.map(function (s) { return s.value; }); }
    function updateMediaFor(v) {
      var g = $('media-gallery'); if (!g || !g.cfShow || !v) return;
      var color = colorIdx >= 0 ? v.options[colorIdx] : null; if (!color) return;
      var sw = $('.ig-variant-swatches__btn[data-value="' + CSS.escape(color) + '"] img', info);
      if (!sw) return;
      var base = (sw.getAttribute('src') || '').split('?')[0].split('/').pop();
      var slides = $$('.product__media-item', g);
      var k = slides.findIndex(function (s) { var im = $('img', s); return im && (im.getAttribute('src') || '').indexOf(base) >= 0; });
      if (k >= 0) g.cfShow(k, true);
    }
    function apply() {
      var v = findVariant(currentOpts());
      $$('input[name="id"]', document).forEach(function (i) {
        if (!v || i.closest('cart-drawer')) return;
        var fid = i.form ? (i.form.getAttribute('id') || '') : '';
        if (i.closest('product-info') || fid.indexOf('product-form') === 0) i.value = v.id;
      });
      $$('.product-form__input', vs).forEach(function (box, k) {
        var lab = $('[id^="custom-label"]', box) || $('label.form__label span', box);
        var val = selects[k] ? selects[k].value : '';
        if (lab) {
          var t = lab.textContent; var name = (P.options[k].name || P.options[k]);
          var sep = /:/.test(t) ? ': ' : ' - ';
          lab.textContent = (t.split(/:| - /)[0].trim() || name) + sep + (k === 1 || /size/i.test(name) ? genderShift(val, women) : val);
        }
        $$('.ig-variant-swatches__btn, .ig-variant-pills__btn', box).forEach(function (b) {
          var on = b.dataset.value === val; b.classList.toggle('ig-variant-swatches__btn--selected', on && b.classList.contains('ig-variant-swatches__btn'));
          b.classList.toggle('ig-variant-pills__btn--selected', on && b.classList.contains('ig-variant-pills__btn')); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      // pares do BOGO seguem a escolha principal
      $$('.quantity-break__selector-item').forEach(function (it) {
        var ss = $$('select', it); currentOpts().forEach(function (o, k) { if (ss[k]) ss[k].value = o; });
      });
      var sticky = $('.sticky-atc__variant-select'); if (sticky) sticky.value = currentOpts().join(',');
      $$('input[name="properties[Gender]"]').forEach(function (i) { i.value = women ? 'Women' : 'Men'; });
      return v;
    }
    selects.forEach(function (s) { s.addEventListener('change', function () { var v = apply(); updateMediaFor(v); }); });
    $$('.ig-variant-swatches__btn, .ig-variant-pills__btn', info).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var box = b.closest('.product-form__input'); var s = $('select.select__select', box); if (!s) return;
        s.value = b.dataset.value; s.dispatchEvent(new Event('change'));
      });
    });
    $$('.custom-gender-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        women = t.dataset.gender === 'women';
        $$('.custom-gender-tab').forEach(function (x) { x.classList.toggle('active', x === t); });
        $$('.ig-variant-pills__btn').forEach(function (b) { var o = b.dataset.originalSize || b.dataset.value; b.dataset.originalSize = o; b.textContent = genderShift(o, women); });
        $$('.quantity-break__selector-item select').forEach(function (s) { $$('option', s).forEach(function (op) { if (/^US /.test(op.value)) { op.dataset.originalSize = op.dataset.originalSize || op.textContent.trim(); op.textContent = genderShift(op.dataset.originalSize, women); } }); });
        apply();
      });
    });
    var sticky = $('.sticky-atc__variant-select');
    if (sticky) sticky.addEventListener('change', function () {
      var parts = sticky.value.split(','); parts.forEach(function (p, k) { if (selects[k]) selects[k].value = p; }); var v = apply(); updateMediaFor(v);
    });
    apply();

    /* adicionar ao carrinho */
    function addItems(items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); });
    }
    function itemsFromForm() {
      var gender = women ? 'Women' : 'Men';
      var props = $('input[name="properties[Gender]"]') ? { Gender: gender } : undefined;
      var chk = $('input[name="quantity"]:checked');
      var lab = chk ? $('label[for="' + chk.id + '"]') : null;
      var qb = lab ? $$('.quantity-break__selector-item', lab) : $$('.quantity-break__selector-item');
      if (chk && lab && !qb.length) { var v1 = apply(); var o1 = { id: v1.id, quantity: Math.max(1, parseInt(chk.value, 10) || 1) }; if (props) o1.properties = props; return [o1]; }
      if (qb.length) {
        return qb.map(function (it) {
          var ss = $$('select', it); var v = findVariant(ss.map(function (s) { return s.value; })) || apply();
          var o = { id: v.id, quantity: 1 }; if (props) o.properties = props; return o;
        });
      }
      var v = apply(); var q = $('input[name="quantity"]:checked') || $('.quantity__input', info);
      var o = { id: v.id, quantity: Math.max(1, parseInt(q && q.value, 10) || 1) }; if (props) o.properties = props; return [o];
    }
    function onAdd(e) {
      e.preventDefault();
      var btn = e.currentTarget; btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true');
      addItems(itemsFromForm()).then(function () { return window.cfCart.refresh(true); })
        .finally(function () { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); });
    }
    $$('.product-form__submit, .main-product-atc', document).forEach(function (b) {
      if (b.closest('cart-drawer')) return;
      var f = b.form || b.closest('form');
      b.addEventListener('click', onAdd);
      if (f) f.addEventListener('submit', function (e) { e.preventDefault(); });
    });
    /* sticky ATC */
    var st = $('sticky-atc');
    if (st) {
      var mainBtn = $('.product-form__submit', info);
      var tick = function () {
        var show = mainBtn ? mainBtn.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        st.classList.toggle('sticky-atc--out', !show);
        st.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
        st.style.transition = 'transform .25s ease';
      };
      window.addEventListener('scroll', tick, { passive: true }); tick();
    }
  }

  /* ---------- carrinho (drawer) ---------- */
  var drawer = $('cart-drawer');
  var tpl = drawer && $('.cf-cart-item-template', drawer.parentElement);
  window.cfCart = {
    open: function () { if (!drawer) { location.href = '/cart'; return; } drawer.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); },
    close: function () { if (!drawer) return; drawer.classList.remove('active'); document.body.classList.remove('overflow-hidden'); },
    refresh: function (open) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        render(c); if (open) window.cfCart.open(); return c;
      });
    }
  };
  if (drawer) {
    drawer.close = window.cfCart.close;
    $$('.drawer__close, #CartDrawer-Overlay', drawer).forEach(function (b) { b.removeAttribute('onclick'); b.addEventListener('click', function (e) { e.preventDefault(); window.cfCart.close(); }); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') window.cfCart.close(); });
  }
  $$('#cart-icon-bubble, a[href="/cart"].header__icon').forEach(function (a) { a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); window.cfCart.refresh(true); }); });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render(c) {
    if (!drawer) return;
    drawer.classList.toggle('is-empty', c.item_count === 0);
    var head = $('.drawer__heading', drawer); if (head) head.textContent = 'Shopping cart • ' + c.item_count + ' Items';
    var ul = $('ul.cart-items', drawer);
    if (ul && tpl) {
      ul.innerHTML = '';
      c.items.forEach(function (it, n) {
        var li = document.createElement('div'); li.innerHTML = tpl.innerHTML.trim();
        li = li.firstElementChild; li.id = 'CartDrawer-Item-' + (n + 1); li.dataset.index = n + 1;
        var img = $('.cart-item__image', li); if (img) { img.src = it.image ? it.image + (it.image.indexOf('?') > 0 ? '&' : '?') + 'width=300' : ''; img.alt = it.product_title; }
        var nm = $('.cart-item__name', li); if (nm) nm.textContent = it.product_title;
        var disc = it.original_line_price > it.final_line_price;
        $$('.cart-item__old-price', li).forEach(function (s) { s.textContent = money(it.original_line_price / it.quantity); s.style.display = disc ? '' : 'none'; });
        var fp = $('.cart-item__final-price', li); if (fp) fp.textContent = money(it.final_line_price / it.quantity);
        var rp = $('.cart-item__totals .regular-price', li); if (rp) rp.textContent = money(it.final_line_price);
        var bd = $('.cart-drawer__discounts', li);
        if (bd) { var t = (it.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean)[0]; if (t) { var sp = $('span', bd); if (sp) sp.textContent = t.toUpperCase(); bd.style.display = ''; } else bd.style.display = 'none'; }
        var dl = $('dl', li);
        if (dl) {
          var h = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="product-option">' + esc(it.variant_title) + '</div>' : '';
          Object.keys(it.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) h += '<div class="product-option"><dt>' + esc(k) + ':</dt><dd>' + esc(it.properties[k]) + '</dd></div>'; });
          dl.innerHTML = h;
        }
        var q = $('.quantity__input', li); if (q) { q.value = it.quantity; q.dataset.index = n + 1; }
        var minus = $('.quantity__button--minus', li); if (minus) minus.classList.toggle('disabled', it.quantity <= 1);
        li.dataset.key = it.key;
        ul.appendChild(li);
      });
    }
    var tot = $('.cart-drawer__totals__row--spaced.text-color-text .cart-drawer__totals__row__money, .cart-drawer__totals__row__money', drawer);
    $$('.cart-drawer__totals__row__money', drawer).forEach(function (el) { el.textContent = money(c.total_price); });
    var bubble = $('.cart-count-bubble span[aria-hidden]'); if (bubble) bubble.textContent = c.item_count;
  }
  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(render);
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var li = e.target.closest('.cart-item'); if (!li || !li.dataset.key) return;
      var q = $('.quantity__input', li); var v = parseInt(q && q.value, 10) || 1;
      if (e.target.closest('cart-remove-button')) { e.preventDefault(); change(li.dataset.key, 0); }
      else if (e.target.closest('.quantity__button--plus')) { e.preventDefault(); change(li.dataset.key, v + 1); }
      else if (e.target.closest('.quantity__button--minus')) { e.preventDefault(); if (v > 1) change(li.dataset.key, v - 1); }
    });
    drawer.addEventListener('change', function (e) { var li = e.target.closest('.cart-item'); if (li && e.target.classList.contains('quantity__input')) change(li.dataset.key, parseInt(e.target.value, 10) || 0); });
    // upsell (palmilhas): liga = adiciona
    $$('cart-drawer-upsell', drawer).forEach(function (u) {
      var sw = $('.upsell__toggle-switch', u); if (!sw) return;
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        var sel = $('select', u); var vid = u.dataset.id;
        if (sel && sel.selectedOptions[0] && sel.selectedOptions[0].dataset.variantId) vid = sel.selectedOptions[0].dataset.variantId;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1 }] }) }).then(function () { return window.cfCart.refresh(false); });
      });
    });
    var co = $('#CartDrawer-Checkout', drawer); if (co) co.addEventListener('click', function (e) { e.preventDefault(); location.href = '/checkout'; });
    window.cfCart.refresh(false);
  }

  /* ---------- reviews (iframe srcdoc, mesma origem) ---------- */
  function fitFrames() {
    $$('iframe.cf-reviews-frame').forEach(function (f) {
      try { var d = f.contentDocument; if (!d) return; var h = d.documentElement.offsetHeight; if (h && Math.abs(h - f.offsetHeight) > 4) { f.style.height = h + 'px'; f.setAttribute('height', h + 'px'); var w = f.closest('#looxReviews'); if (w) w.style.height = h + 'px'; } } catch (e) { }
    });
  }
  setInterval(fitFrames, 300);

  function ready() { initSplides(); setHeaderHeight(); }
  if (window.Splide) ready(); else window.addEventListener('load', ready);
})();
